import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/matches_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-1991dbeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "page-title-icon"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "page-title-text-area" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Matches")
  ])
], -1))

import ProfileMatchesEditor from './ProfileMatchesEditor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMatchesPage',
  props: {
    personId: {}
  },
  setup(__props: any) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(ProfileMatchesEditor, {
      "person-id": props.personId,
      "show-sets": ""
    }, null, 8, ["person-id"])
  ]))
}
}

})